module.exports = __webpack_public_path__ + "static/media/phone.5c049c45.svg";